import React from 'react';
import styled from 'styled-components';
import FinalizeCard from '../FinalizeCard';
import BeneficiaryCard, { beneficiaryCategories } from './BeneficiaryCard';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { getSectionIcon } from 'shared/components/WelcomeBack/Sections';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { Beneficiaries } from '../../Beneficiary/utils/beneficiaryInterfaces';

interface BeneficiaryFinalizeCardProps {
  handleOpen: () => unknown;
  isLoading: boolean;
  beneficiaries: Beneficiaries;
}

const StyledDiv = styled.div`
  margin-top: ${SPACERS.extraLarge};
  margin-bottom: 150px;
  .subheading-page,
  .heading-page {
    text-align: center;
    max-width: 730px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: ${SPACERS.large};
  }
  .card-content {
    margin-bottom: ${SPACERS.large};
  }
  .card {
    max-width: 454px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const BeneficiaryFinalizeCard: React.FC<BeneficiaryFinalizeCardProps> = ({
  beneficiaries,
  isLoading,
  handleOpen,
}) => {
  return (
    <StyledDiv>
      <TrueImpactText variant="heading-page" className="heading-page">
        Do you need to make any changes to the beneficiaries your program
        serves?
      </TrueImpactText>
      <TrueImpactText variant="body-large" className="subheading-page">
        If everything looks good, feel free to continue to the next section.
      </TrueImpactText>
      <FinalizeCard
        icon={getSectionIcon('beneficiaries')}
        title="Beneficiaries"
        subheading="This represents the demographic categories of your program's beneficiaries."
        onClick={handleOpen}
        marginBottom={SPACERS.large}
        isLoading={isLoading}
        className="card"
      >
        {beneficiaryCategories.map(category => (
          <BeneficiaryCard
            key={category}
            category={category}
            beneficiaries={beneficiaries}
          />
        ))}
      </FinalizeCard>
    </StyledDiv>
  );
};

export default BeneficiaryFinalizeCard;
